module.exports = __webpack_public_path__ + "media/Components/fonts/CarterOne-087378fa59f33034a3ef685afa44bbb3.ttf";